import { Permission } from "./permission";

export class PermissionType {
    permissionTypeId?: number;
    permissionTypeName: string;
    permissionTypeSlug: string;
    permission: Permission[];
}